import React from 'react'
import { ElementProps } from '../base/element'
import { IContainerComponent } from '../schemamanager/types'

export interface IFormComponent extends IContainerComponent {
  type: 'form'
}

export const Form = ({sm, children, mergeStyles, events}: ElementProps) => {
  const onSubmit = (event: any) => {
    if (sm.Schema.onSubmit) {
      sm.Schema.onSubmit({sm, comp: sm.Schema, event})
    }
  }

  const onReset = (event: any) => {
    if (sm.Schema.onReset) {
      sm.Schema.onReset({sm, comp: sm.Schema, event})
    }
  }

  const m = mergeStyles({main: {classes: {}}})
  return (
    <form {...m.main} onSubmit={onSubmit} onReset={onReset} {...events()}>
      {children}
    </form>
  )
}
